import type { ReactNode } from "react";
import { Breadcrumbs, SideNav, TopNav, TabNav, MenuTree, RouteTabs, AnchorNav, Pagination, Stepper, WizardNav, BackLink } from "@swot/base-components";

export { Breadcrumbs, SideNav, TopNav, TabNav, MenuTree, RouteTabs, AnchorNav, Pagination, Stepper, WizardNav, BackLink } from "@swot/base-components";

export function SwotTopNavigation({ children, className }: { children: ReactNode; className?: string | undefined }) {
  return <nav className={className} aria-label="Top navigation">{children}</nav>;
}

export function SwotBreadcrumb({ items, className }: { items: readonly string[]; className?: string | undefined }) {
  return (
    <nav className={className} aria-label="Breadcrumb">
      {items.map((item, index) => <span key={`${item}-${index}`}>{item}</span>)}
    </nav>
  );
}
